import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/teacher-course-table-store';

const TeacherCourseTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default TeacherCourseTableContextWrapper;
